import { history } from '../redux/store';
import jwt_decode from 'jwt-decode';

export function navigateHome() {
  history.push('/vertical/default-dashboard');
}
